<app-list-module-table variant="surface" [columns]="columns" [rows]="rows" [loading]="loading"
  [emptyMessage]="emptyMessage" [rowTrackFn]="trackAgentRow">
  <ng-template listCellDef="serial" let-i="index">
    {{ serialNumber(i) }}
  </ng-template>

  <ng-template listCellDef="agentId" let-row="row">
    @if (P.AGENT_VIEW | hasPermission) {
    @if (agentDetailRoute(row); as detailLink) {
    <a [routerLink]="detailLink" class="font-bold text-primary hover:underline dark:text-white">
      {{ row.agent_code ?? '—' }}
    </a>
    } @else {
    <button type="button"
      class="cursor-pointer border-0 bg-transparent p-0 font-mono text-xs font-bold text-primary hover:underline dark:text-white"
      (click)="viewDetail.emit(row)">
      {{ row.agent_code ?? '—' }}
    </button>
    }
    } @else {
    <span class="font-mono text-xs font-bold">{{ row.agent_code ?? '—' }}</span>
    }
  </ng-template>

  <ng-template listCellDef="agentName" let-row="row">
    {{ row.name }}
  </ng-template>

  <ng-template listCellDef="client" let-row="row">
    @if (P.AGENT_VIEW | hasPermission) {
    <div class="block">
      <div class="font-medium text-gray-700 dark:text-gray-300">{{ row.tenant?.tenant_name ?? '—' }}</div>
    </div>
    }
  </ng-template>

  <ng-template listCellDef="product" let-row="row">
    @if (P.AGENT_VIEW | hasPermission) {
    {{ row.product?.name ?? '—' }}
    }
  </ng-template>

  <ng-template listCellDef="workflow" let-row="row">
    @if (P.AGENT_VIEW | hasPermission) { @if (row.workflow) {
    <span class="whitespace-nowrap">{{ row.workflow }}</span>
    } @else {
    <!-- No published flow matches this agent's country and product, so it cannot run. -->
    <span class="whitespace-nowrap text-amber-700 dark:text-amber-400" title="No published workflow matches this agent's country and product">
      Not published
    </span>
    } }
  </ng-template>

  <ng-template listCellDef="trainedOn" let-row="row">
    {{ row.trained_at | appDate }}
  </ng-template>

  <ng-template listCellDef="status" let-row="row">
    <div class="inline-flex items-center rounded-full py-1 px-3" [ngClass]="statusBadgeClass(row.status)">
      {{ statusLabel(row.status) }}
    </div>
  </ng-template>

  <ng-template listCellDef="totalPds" let-row="row">
    {{ row.total_pds ?? 0 }}
  </ng-template>

  <ng-template listCellDef="actions" let-row="row" let-i="index">
    <div class="agent-action-menu relative inline-flex justify-end">
      <button type="button"
        class="rounded-lg p-1.5 text-gray-600 hover:bg-black/[0.06] dark:text-gray-400 dark:hover:bg-white/10"
        (click)="toggleMenu.emit({ key: actionMenuRowKey(i), event: $event })"
        [attr.aria-expanded]="openActionMenuKey === actionMenuRowKey(i)" aria-haspopup="menu" aria-label="Row actions">
        <icon-horizontal-dots class="size-5 rotate-90" />
      </button>
      @if (openActionMenuKey === actionMenuRowKey(i)) {
      <div
        appActionMenuPanel
        class="min-w-[11rem] rounded-xl border border-gray-200 bg-white shadow-lg dark:border-[#191e3a] dark:bg-[#0e1726]"
        role="menu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        @if (P.AGENT_VIEW | hasPermission) {
        @if (agentDetailRoute(row); as detailLink) {
        <a role="menuitem" [routerLink]="detailLink" (click)="closeMenu.emit()"
          class="flex w-full items-center gap-3 rounded-t-xl px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5">
          <icon-eye class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          View details
        </a>
        } @else {
        <button type="button" role="menuitem" (click)="closeMenu.emit(); viewDetail.emit(row)"
          class="flex w-full items-center gap-3 rounded-t-xl px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5">
          <icon-eye class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          View details
        </button>
        }
        }
        @if (!isDeletedTab) {
        @if (P.AGENT_RETRAIN | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
          (click)="closeMenu.emit(); retrain.emit(row)">
          <icon-server class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          Retrain
        </button>
        }
        @if (P.AGENT_ASSIGN_TO_CLIENT | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
          (click)="closeMenu.emit(); assign.emit(row)">
          <icon-user-plus class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          Assign to Client
        </button>
        }
        @if (P.AGENT_UPDATE | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
          (click)="closeMenu.emit(); version.emit(row)">
          <icon-server class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          New version
        </button>
        }
        @if (
        canToggleLifecycle(row) &&
        (
        (isPauseMenuAction(row) && (P.AGENT_TOGGLE_STATUS | hasPermission)) ||
        (isGoLiveMenuAction(row) && (P.AGENT_GO_LIVE | hasPermission)) ||
        (isResumeMenuAction(row) && (P.AGENT_TOGGLE_STATUS | hasPermission))
        )
        ) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
          (click)="closeMenu.emit(); pauseAgent.emit(row)">
          @if (isPauseMenuAction(row)) {
          <icon-lock class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          } @else {
          <icon-play-circle class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          }
          {{ lifecycleLabel(row) }}
        </button>
        }
        @if (P.AGENT_DELETE | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 rounded-b-xl px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-gray-50 dark:hover:bg-white/5"
          (click)="closeMenu.emit(); delete.emit(row)">
          <icon-trash-lines class="size-4 shrink-0 text-danger" />
          Delete
        </button>
        }
        } @else {
        @if (P.AGENT_RESTORE | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
          [ngClass]="(P.AGENT_DELETE | hasPermission) ? '' : 'rounded-b-xl'"
          (click)="closeMenu.emit(); restore.emit(row)">
          <icon-restore class="size-4 shrink-0 text-[#18214d] dark:text-white" />
          Restore
        </button>
        }
        @if (P.AGENT_DELETE | hasPermission) {
        <button type="button" role="menuitem"
          class="flex w-full items-center gap-3 rounded-b-xl px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-gray-50 dark:hover:bg-white/5"
          (click)="closeMenu.emit(); permanentDelete.emit(row)">
          <icon-trash-lines class="size-4 shrink-0 text-danger" />
          Delete permanently
        </button>
        }
        }
      </div>
      }
    </div>
  </ng-template>
</app-list-module-table>